import React from 'react'
import styles from './QRCodeContainer.scss'
import { Icon } from 'common/Icon'
import { Msg, useFormatMessage } from 'lib/localization'
import { CTA } from 'common/styleguide/CTA'
import QRCode from 'qrcode.react'
import cx from 'classnames'

export const QRCodeContainer = ({
  experienceId,
  appCode,
  label, // this is expected to be an intl message
  tip, // this is expected to be an intl message
  centered,
  disabled
}) => {
  const fm = useFormatMessage()

  const download = ext => {
    if (disabled) { return }
    window.location = `/experiences/${experienceId}/qr_code.${ext}?code=${appCode.code}`
  }

  return <div className={styles.qrContainer}>
    {label && <span><Msg m={label} /> <Icon i='ios-information-circle-outline' data-tip title={fm(tip)} /></span> }
    <div className={cx(styles.qrCode, centered && styles.centered)}>
      <QRCode value={`rwgps://app/code/${appCode.code.toUpperCase()}`} size={centered ? 200 : 80} level='M' />
    </div>
    <div className={styles.qrActions}>
      <CTA disabled={disabled} secondary inline margins={false}
        onClick={() => download('png')}>
        <Icon size={20} i='md-download' /> Download PNG
      </CTA>
      <CTA disabled={disabled} link inline margins={false} className={styles.secondaryDownload}
        onClick={() => download('svg')}>
        <Icon size={20} i='md-download' /> SVG
      </CTA>
    </div>
  </div>
}
